import { LoadingOutlined } from "@ant-design/icons";
import { Storage } from "aws-amplify";
import React, { useState } from "react";
import { ImageFile } from "../../interfaces";

type Props = {
  files: ImageFile[];
};

const Attachments: React.FC<Props> = ({ files }) => {
  const [downloadingFiles, setDownloadingFiles] = useState<{
    [key: string]: string;
  }>({});

  const handleFileDownload = async (key: string, signedUrl: string) => {
    const element = document.createElement("a");
    element.style.display = "none";
    element.setAttribute("href", signedUrl);
    element.setAttribute("target", "_blank");
    element.setAttribute("download", key);
    document.body.appendChild(element);
    element.click();
    element.remove();
  };

  const handleDownload = async ({ key }: ImageFile) => {
    setDownloadingFiles({ ...downloadingFiles, [key]: key });
    const signedUrl = await Storage.get(key);
    const { [key]: removed, ...rest } = downloadingFiles;
    setTimeout(() => {
      setDownloadingFiles({ ...rest });
      handleFileDownload(key, signedUrl);
    }, 100);
  };

  return (
    <>
      {files.length === 0 && <span>No files</span>}
      {files.map((file) => (
        <div className="image-files__file">
          <span onClick={() => handleDownload(file)}>
            {downloadingFiles[file.key] && (
              <LoadingOutlined style={{ marginRight: 5 }} />
            )}
            <span>{file.name}</span>
          </span>
        </div>
      ))}
    </>
  );
};

export default Attachments;
